export const changeFavicon = (href: string) => {
	// Ensure we have access to the document, i.e. we are in the browser.
	if (typeof window === 'undefined') return;

	const link: HTMLBaseElement =
		window.document.querySelector("link[rel*='icon']") || window.document.createElement('link');
	link.href = href;

	window.document.getElementsByTagName('head')[0].appendChild(link);
};
